import { useContext } from "react";

import { MeetingsContext } from "./MeetingsContext";

export function useMeetings() {
  const context = useContext(MeetingsContext);
  if (!context) {
    throw new Error("useMeetings must be used within a MeetingsProvider");
  }
  return context;
}
